import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-40d14f18")

_pushScopeId("data-v-40d14f18")
const _hoisted_1 = { class: "p-pb-4 p-d-flex p-jc-between p-ai-center" }
const _hoisted_2 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_3 = { class: "p-field p-col-12 p-md-4" }
const _hoisted_4 = { class: "p-input-icon-left" }
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_6 = { class: "p-d-none p-d-md-block p-field p-col" }
const _hoisted_7 = { class: "p-d-flex p-ai-center p-flex-wrap" }
const _hoisted_8 = { class: "p-ml-auto p-mr-2" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "p-mr-2" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "p-mr-2" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "p-d-flex p-mb-2" }
const _hoisted_18 = { style: {"margin":"-1rem"} }
const _hoisted_19 = {
  class: "p-d-none p-d-md-block",
  style: {"overflow-x":"auto"}
}
const _hoisted_20 = {
  key: 1,
  class: "p-text-nowrap p-text-truncate"
}
const _hoisted_21 = {
  key: 0,
  class: "p-d-flex p-jc-center p-ai-center"
}
const _hoisted_22 = {
  key: 1,
  class: "p-d-flex p-jc-center p-ai-center"
}
const _hoisted_23 = { class: "p-d-block p-d-md-none p-grid" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Empty = _resolveComponent("Empty")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_FolderBreadcrumb = _resolveComponent("FolderBreadcrumb")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_FolderSelector = _resolveComponent("FolderSelector")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Column = _resolveComponent("Column")!
  const _component_ExperimentTag = _resolveComponent("ExperimentTag")!
  const _component_InlineText = _resolveComponent("InlineText")!
  const _component_DatasourceStatus = _resolveComponent("DatasourceStatus")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_CardItem = _resolveComponent("CardItem")!
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.isEmpty)
    ? (_openBlock(), _createBlock(_component_Empty, {
        key: 0,
        workspaceId: _ctx.workspaceId
      }, null, 8, ["workspaceId"]))
    : (_ctx.loadCount === 0)
      ? (_openBlock(), _createBlock(_component_ProgressSpinner, {
          key: 1,
          class: "p-d-flex p-jc-between p-ai-center",
          style: {"height":"100%"}
        }))
      : (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
          _createVNode("div", _hoisted_1, [
            _createVNode(_component_FolderBreadcrumb, { workspaceId: _ctx.workspaceId }, null, 8, ["workspaceId"]),
            (_ctx.canEdit())
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  icon: "pi pi-plus",
                  label: _ctx.$matchMedia.desktop ? _ctx.$t('button.create_datasource') : '',
                  onClick: _ctx.onClickCreate
                }, null, 8, ["label", "onClick"]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode("span", _hoisted_4, [
                _hoisted_5,
                _createVNode(_component_InputText, {
                  type: "text",
                  modelValue: _ctx.searchKey,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchKey = $event)),
                  placeholder: _ctx.$t('label.search')
                }, null, 8, ["modelValue", "placeholder"])
              ])
            ]),
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode("div", _hoisted_8, [
                  _createVNode(_component_Dropdown, {
                    modelValue: _ctx.selectedOwner,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedOwner = $event)),
                    options: _ctx.uniqueUsersOfDatasources,
                    placeholder: _ctx.$t('autots.overview.select.by.owner'),
                    showClear: !!_ctx.selectedOwner
                  }, {
                    value: _withId((slotProps) => [
                      (slotProps.value)
                        ? (_openBlock(), _createBlock("div", _hoisted_9, _toDisplayString(_ctx.getFullname(slotProps.value)), 1))
                        : (_openBlock(), _createBlock("span", _hoisted_10, _toDisplayString(slotProps.placeholder), 1))
                    ]),
                    option: _withId((slotProps) => [
                      _createTextVNode(_toDisplayString(_ctx.getFullname(slotProps.option)), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "options", "placeholder", "showClear"])
                ]),
                _createVNode("div", _hoisted_11, [
                  _createVNode(_component_Dropdown, {
                    modelValue: _ctx.selectedType,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedType = $event)),
                    options: _ctx.listType,
                    placeholder: _ctx.$t('autots.overview.select.by.type'),
                    showClear: !!_ctx.selectedType
                  }, {
                    value: _withId((slotProps) => [
                      (slotProps.value)
                        ? (_openBlock(), _createBlock("div", _hoisted_12, _toDisplayString(_ctx.$t(`item.type.${slotProps.value}`)), 1))
                        : (_openBlock(), _createBlock("span", _hoisted_13, _toDisplayString(slotProps.placeholder), 1))
                    ]),
                    option: _withId((slotProps) => [
                      _createTextVNode(_toDisplayString(_ctx.$t(`item.type.${slotProps.option}`)), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "options", "placeholder", "showClear"])
                ]),
                _createVNode("div", _hoisted_14, [
                  _createVNode(_component_Dropdown, {
                    modelValue: _ctx.selectedStatus,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectedStatus = $event)),
                    options: _ctx.listStatus,
                    placeholder: _ctx.$t('autots.overview.select.by.status'),
                    showClear: !!_ctx.selectedStatus
                  }, null, 8, ["modelValue", "options", "placeholder", "showClear"])
                ]),
                _createVNode("div", null, [
                  _createVNode(_component_Dropdown, {
                    modelValue: _ctx.selectedTimeRange,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectedTimeRange = $event)),
                    options: _ctx.timeRanges,
                    placeholder: _ctx.$t('autots.overview.select.by.time')
                  }, {
                    value: _withId((slotProps) => [
                      (slotProps && slotProps.value && slotProps.value.name)
                        ? (_openBlock(), _createBlock("div", _hoisted_15, _toDisplayString(_ctx.$t(slotProps.value.name)), 1))
                        : (_openBlock(), _createBlock("div", _hoisted_16, _toDisplayString(slotProps.placeholder), 1))
                    ]),
                    option: _withId((slotProps) => [
                      _createTextVNode(_toDisplayString(_ctx.$t(slotProps.option.name)), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "options", "placeholder"])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_17, [
            (_ctx.canEdit())
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  label: _ctx.$t('button.new.folder'),
                  icon: "bx bx-folder-plus",
                  class: "p-button-text",
                  onClick: _ctx.callCreateFolder
                }, null, 8, ["label", "onClick"]))
              : _createCommentVNode("", true),
            (_ctx.canEdit())
              ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                  key: 1,
                  disabled: _ctx.selectedColumn.length == 0,
                  icon: "bx bx-sm bx-share bx-flip-horizontal",
                  class: "p-ml-auto p-button-rounded p-button-secondary p-button-text",
                  onClick: _ctx.onToggleSelectFolder
                }, null, 8, ["disabled", "onClick"])), [
                  [
                    _directive_tooltip,
                    _ctx.$t('button.move'),
                    void 0,
                    { top: true }
                  ]
                ])
              : _createCommentVNode("", true),
            _createVNode(_component_OverlayPanel, {
              ref: "op",
              style: {"width":"450px"},
              appendTo: "body"
            }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_18, [
                  _createVNode(_component_FolderSelector, {
                    "disabled-children": _ctx.targetFolderIds,
                    "disabled-selection": _ctx.disabledDestinationFolders,
                    children: _ctx.folders,
                    "has-more-children": _ctx.hasMoreFolders,
                    current: _ctx.selectedFolder,
                    onCancel: _ctx.onCancel,
                    onSelect: _ctx.onSelect,
                    onNavigate: _ctx.onNavigate,
                    onLoadMore: _ctx.onLoadMore
                  }, null, 8, ["disabled-children", "disabled-selection", "children", "has-more-children", "current", "onCancel", "onSelect", "onNavigate", "onLoadMore"])
                ])
              ]),
              _: 1
            }, 512),
            (_ctx.canEdit())
              ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                  key: 2,
                  disabled: _ctx.selectedColumn.length == 0,
                  class: "p-button-rounded p-button-secondary p-button-text",
                  icon: "pi pi-trash",
                  onClick: _ctx.onClickDeleteMultiple
                }, null, 8, ["disabled", "onClick"])), [
                  [
                    _directive_tooltip,
                    _ctx.$t('button.delete'),
                    void 0,
                    { top: true }
                  ]
                ])
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_19, [
            _createVNode(_component_DataTable, {
              value: _ctx.datasources,
              selectionMode: "multiple",
              onRowSelect: _ctx.onRowSelect,
              scrollable: true,
              scrollHeight: "flex",
              onSort: _ctx.onSort,
              sortField: _ctx.dynamicSortField,
              sortOrder: _ctx.dynamicSortOrder,
              loading: _ctx.loading
            }, {
              footer: _withId(() => [
                (_ctx.hasMoreDatasource())
                  ? (_openBlock(), _createBlock("div", _hoisted_21, [
                      _createVNode(_component_Button, {
                        label: _ctx.$t('button.more'),
                        class: "p-button-text",
                        onClick: _ctx.loadMoreDatasources
                      }, null, 8, ["label", "onClick"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.datasources && _ctx.datasources.length == 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_22, _toDisplayString(_ctx.$t("datasource.list-datasource.table.empty")), 1))
                  : _createCommentVNode("", true)
              ]),
              default: _withId(() => [
                (_ctx.canEdit())
                  ? (_openBlock(), _createBlock(_component_Column, {
                      key: 0,
                      style: {"max-width":"3rem"}
                    }, {
                      header: _withId(() => [
                        _createVNode(_component_Checkbox, {
                          modelValue: _ctx.isCheckedAll,
                          binary: true,
                          onClick: _ctx.onClickCheckboxAll
                        }, null, 8, ["modelValue", "onClick"])
                      ]),
                      body: _withId((slotProps) => [
                        _createVNode(_component_Checkbox, {
                          value: slotProps.data,
                          modelValue: _ctx.selectedColumn,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectedColumn = $event)),
                          onClick: _ctx.onClickCheckbox
                        }, null, 8, ["value", "modelValue", "onClick"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_Column, {
                  field: "name",
                  header: _ctx.$t('datasource.list-datasource.table.column.name'),
                  sortable: true,
                  headerClass: "name-column",
                  bodyClass: "name-column"
                }, {
                  body: _withId(({ data }) => [
                    _createVNode(_component_ExperimentTag, {
                      name: data.type
                    }, null, 8, ["name"]),
                    (data.id === _ctx.editingId)
                      ? (_openBlock(), _createBlock(_component_InlineText, {
                          key: 0,
                          model: _ctx.newName,
                          "onUpdate:model": _cache[7] || (_cache[7] = ($event: any) => (_ctx.newName = $event)),
                          onCancel: _ctx.cancelEditName,
                          onAccept: ($event: any) => (_ctx.updateCurrentName(data))
                        }, null, 8, ["model", "onCancel", "onAccept"]))
                      : (_openBlock(), _createBlock("div", _hoisted_20, [
                          _createVNode(_component_Button, {
                            class: "p-button-link p-p-0",
                            label: data.name,
                            onClick: ($event: any) => (_ctx.openDatasource(data)),
                            style: {"color":"var(--text-color)"}
                          }, null, 8, ["label", "onClick"])
                        ]))
                  ]),
                  _: 1
                }, 8, ["header"]),
                _createVNode(_component_Column, {
                  field: "createdBy",
                  header: _ctx.$t('datasource.list-datasource.table.column.owner')
                }, {
                  body: _withId((slotProps) => [
                    _createVNode("div", null, _toDisplayString(_ctx.getFullname(slotProps.data.createdBy)), 1)
                  ]),
                  _: 1
                }, 8, ["header"]),
                _createVNode(_component_Column, {
                  field: "status",
                  header: _ctx.$t('datasource.list-datasource.table.column.status')
                }, {
                  body: _withId((slotProps) => [
                    (slotProps.data.type !== 'FOLDER')
                      ? (_openBlock(), _createBlock(_component_DatasourceStatus, {
                          key: 0,
                          status: slotProps.data.status
                        }, null, 8, ["status"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["header"]),
                _createVNode(_component_Column, {
                  field: "lastModifiedDate",
                  header: _ctx.$t('datasource.list-datasource.table.column.updated_date'),
                  sortable: true
                }, {
                  body: _withId((slotProps) => [
                    _withDirectives(_createVNode("span", null, [
                      _createTextVNode(_toDisplayString(_ctx.$moment(slotProps.data.lastModifiedDate).fromNow()), 1)
                    ], 512), [
                      [
                        _directive_tooltip,
                        
                _ctx.$moment(slotProps.data.lastModifiedDate).format('LLLL')
              ,
                        void 0,
                        { top: true }
                      ]
                    ])
                  ]),
                  _: 1
                }, 8, ["header"]),
                (_ctx.canEdit())
                  ? (_openBlock(), _createBlock(_component_Column, {
                      key: 1,
                      header: _ctx.$t('autots.overview.action')
                    }, {
                      body: _withId((slotProps) => [
                        _withDirectives(_createVNode(_component_Button, {
                          class: "p-button-rounded p-button-secondary p-button-text",
                          icon: "pi pi-pencil",
                          onClick: ($event: any) => (_ctx.onEdit($event, slotProps.data))
                        }, null, 8, ["onClick"]), [
                          [
                            _directive_tooltip,
                            _ctx.$t('button.rename'),
                            void 0,
                            { top: true }
                          ]
                        ]),
                        _withDirectives(_createVNode(_component_Button, {
                          class: "p-button-rounded p-button-secondary p-button-text",
                          icon: "pi pi-trash",
                          onClick: ($event: any) => (_ctx.confirmDeleteDatasource($event, slotProps.data))
                        }, null, 8, ["onClick"]), [
                          [
                            _directive_tooltip,
                            _ctx.$t('button.delete'),
                            void 0,
                            { top: true }
                          ]
                        ])
                      ]),
                      _: 1
                    }, 8, ["header"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["value", "onRowSelect", "onSort", "sortField", "sortOrder", "loading"])
          ]),
          _createVNode("div", _hoisted_23, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.datasources, (datasource) => {
              return (_openBlock(), _createBlock("div", {
                class: "p-col-12 p-md-6",
                key: datasource.id
              }, [
                _createVNode(_component_router_link, {
                  to: `/workspace/${_ctx.workspaceId}/datasource/${datasource.id}`
                }, {
                  default: _withId(() => [
                    _createVNode(_component_CardItem, {
                      name: datasource.name,
                      type: 'datasource',
                      status: datasource.status,
                      createdBy: datasource.createdBy,
                      createdDate: datasource.createdDate
                    }, null, 8, ["name", "status", "createdBy", "createdDate"])
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]))
            }), 128))
          ])
        ], 64))
})